var map = {
	"./emoji-accommodation@3x.png": 845,
	"./emoji-cash@3x.png": 846,
	"./emoji-chat@3x.png": 847,
	"./emoji-documents@3x.png": 848,
	"./emoji-expenses@3x.png": 849,
	"./emoji-hot-air-balloon@3x.png": 850,
	"./emoji-island@3x.png": 851,
	"./emoji-note-book@3x.png": 852,
	"./emoji-photos@3x.png": 853,
	"./emoji-pin@3x.png": 854,
	"./emoji-suitcase@3x.png": 855
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1664;